import { useCallback } from 'react';

import PropTypes from 'prop-types';

import Banner from '@zenbusiness/zui/Banner';
import DismissBanner from '@zenbusiness/zui/DismissBanner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';

import { ErrorBoundary } from '#client/components/ErrorBoundary';
import { useBanners } from '#client/hooks/useBanners';

import * as Styled from './HomeBanners.style';

function HomeBanners({ onOpenModal }) {
  const { data, error, loading } = useBanners();

  const handleCtaClick = useCallback(
    (cta = {}) => {
      if (cta.modalName) {
        onOpenModal(cta.modalName);
      }
    },
    [onOpenModal]
  );

  if (loading || error) {
    return null;
  }

  const banner = data?.[0];

  if (!banner) {
    return null;
  }

  const createAction = (cta) => ({
    label: cta.label,
    ...(cta.modalName && { onClick: () => handleCtaClick(cta) }),
    ...(cta.url && { href: cta.url })
  });

  const slotProps = {
    ...(banner.primaryCta && { primaryAction: createAction(banner.primaryCta) }),
    ...(banner.secondaryCta && { secondaryAction: createAction(banner.secondaryCta) })
  };

  const slots = {
    ...(banner.imageUrl && {
      startIcon: <SharedAsset
        alt="start-icon-banner"
        src={banner.imageUrl}
      />
    })
  };

  const BannerComponent = banner.dismissible ? DismissBanner : Banner;

  return (
    <Styled.HomeBanners>
      <ErrorBoundary id="src/Home#Banners">
        <BannerComponent
          clickstreamProps={{ appSection: 'home' }}
          title={banner.title}
          subtitle={banner.description}
          variant={banner.type}
          slotProps={slotProps}
          slots={slots}
        />
      </ErrorBoundary>
    </Styled.HomeBanners>
  );
}

HomeBanners.propTypes = {
  onOpenModal: PropTypes.func.isRequired
};

export default HomeBanners;
